import gql from 'graphql-tag';

export const getAllCouponsByAdmin = gql`
  query getAllCouponsByAdmin($input: inputCouponsAdmin) {
    getAllCouponsByAdmin(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      coupons {
        id
        recordType
        value
        accumulatedDealCoins
        status
        dateTriggered
        dateRedeemed
        consumer {
          username
        }
        merchant {
          username
        }
      }
    }
  }
`;
